const SEO = [
	{
		page: "profile",
		description:
			"I’m a software engineering graduate who thrives at the intersection of creativity, logic, and impact. Over the years, I’ve built solid experience working across the stack — from crafting responsive frontend interfaces to developing reliable backend systems.My love for technology extends beyond software development into data science. I’ve completed several independent data projects that have strengthened my analytical thinking and fueled my pursuit of mastering machine learning.Beyond code, I’m deeply inspired by growth and collaboration. I enjoy being part of tech communities that foster innovation and knowledge-sharing, and I actively seek spaces where I can both learn and contribute. I’m also nurturing my passion for public speaking, aiming to inspire others through storytelling and shared experiences in tech.",
		keywords: ["Manase", "Manase Gunga", "Manase Gunga Karisa"],
	},

	{
		page: "projects",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to.",
		keywords: ["Manase Gunga's Projects", "Vaslink", "Dr Mordi Medical Web App", "React Developer"],
	},

	{
		page: "about",
		description:
			"From frontend engineering to backend architecture and data exploration, my experience reflects a deep passion for solving real problems with technology. I’ve worked on diverse projects, taken on multiple roles, and continually refined my skills to stay adaptable in an ever-evolving tech landscape.",
		keywords: ["Manase", "Manase Gunga", "Manase Gunga Karisa"],
	},

	{
		page: "blog",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
		keywords: ["Manase", "Manase Gunga", "Manase Gunga Karisa"],
	},

	{
		page:"publicspeaking",
		descritpion: "sdononoiec",
		keywords:["Public Speaking"]
	}


];

export default SEO;
